// In src/pages/WaysToGivePage.js

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../services/firebase';
import { collection, query, onSnapshot, orderBy } from 'firebase/firestore';

import { Container, Typography, Box, Grid, Card, CardContent, CircularProgress, Link, Button } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';

function WaysToGivePage() {
  const { userProfile } = useAuth();
  const [givingMethods, setGivingMethods] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userProfile?.churchId) {
      setLoading(false);
      return;
    }

    const givingMethodsRef = collection(db, 'churches', userProfile.churchId, 'givingInfo');
    const q = query(givingMethodsRef, orderBy('order', 'asc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setGivingMethods(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    }, (error) => {
      console.error("Error fetching giving methods:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userProfile]);

  if (loading) {
    return <CircularProgress />;
  }
  
  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom>Ways to Give</Typography>
      {/* --- Start of Final Fix --- */}
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Thank you for your generosity! Your gift helps us share God’s love and serve our community. Choose a giving option below to donate quickly and securely.
      </Typography>
      {/* --- End of Final Fix --- */}

      {givingMethods.length === 0 && (
        <Typography>No giving methods have been set up yet.</Typography>
      )}

      <Grid container spacing={3}>
        {givingMethods.map((method) => (
          <Grid item xs={12} sm={6} md={4} key={method.id}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                {method.icon && (
                  <Box sx={{ mb: 2 }}>
                    <img src={method.icon} alt={method.title} style={{ width: '64px', height: '64px', objectFit: 'contain' }} />
                  </Box>
                )}
                <Typography gutterBottom variant="h5" component="h2">
                  {method.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {method.description}
                </Typography>
                {method.link && (
                  <Link href={method.link} target="_blank" rel="noopener noreferrer">
                    <Button variant="contained" startIcon={<LaunchIcon />}>
                      Give Now
                    </Button>
                  </Link>
                )}
                {method.accountHandle && (
                  <Typography variant="body1" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {method.accountHandle}
                  </Typography>
                )}
                {method.qrCodeUrl && (
                  <Box sx={{ mt: 2 }}>
                    <img src={method.qrCodeUrl} alt={`${method.title} QR Code`} style={{ maxWidth: '100%', height: 'auto' }} />
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default WaysToGivePage;